import PropTypes from "prop-types"
import React from "react"

const HeadingHeroTitle = ({ children }) => {
  return (
    <div
      data-design-system="HeadingHeroTitle"
      aria-level="1"
      role="heading"
      className="text-[28px] font-bold leading-tight text-gray-900 lg:text-[42px]"
    >
      {children}
    </div>
  )
}

HeadingHeroTitle.propTypes = {
  children: PropTypes.node.isRequired,
}

export default HeadingHeroTitle
